import { useEffect, useRef } from "react";
import { Marker } from "react-leaflet";
import { GPS_EVERY } from "@/lib/tracking";

export function MovingMarker({ position, icon, duration = GPS_EVERY, children }) {
  const ref = useRef(null);
  const first = useRef(position);
  const raf = useRef(0);
  const [lat, lng] = position;
  useEffect(() => {
    const m = ref.current;
    if (!m) return undefined;
    const from = m.getLatLng();
    const a = [from.lat, from.lng];
    if (Math.abs(a[0] - lat) < 1e-7 && Math.abs(a[1] - lng) < 1e-7) return undefined;
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / duration);
      m.setLatLng([a[0] + (lat - a[0]) * k, a[1] + (lng - a[1]) * k]);
      if (k < 1) raf.current = requestAnimationFrame(step);
    };
    cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [lat, lng, duration]);
  return <Marker ref={ref} position={first.current} icon={icon}>{children}</Marker>;
}
